import Printable from '@/utilities/Printable'
import i18n from '@/i18n';

export default class ReportPrintableGenerator {

    constructor(type, reportData) {
        this.type = type
        this.reportData = reportData
    }

    getPrintable() {
        const methodName = 'get' + this.type.replace(/(_|^)(\w)/g, (match, p1, p2) => p2.toUpperCase()) + 'Printable';
        if (typeof this[methodName] === 'function') {
            return this[methodName]();
        }

        return new Printable()
    }

    getBarLedgerPrintable() {
        const pr = new Printable()

        pr.l('L', '')
        pr.l('L', i18n.t('reports.body.bar_ledger.document_short'), { align: 'R' })
        pr.l('L', '')
        pr.l('L', i18n.t('reports.body.bar_ledger.document_number'), { align: 'R' })
        pr.l('L', '')
        pr.l('L', '')
        pr.l('L', i18n.t('reports.body.bar_ledger.heading').toUpperCase(), { align: 'C' })

        const fullDays = this.reportData.start_time?.includes('00:00:00') && this.reportData.end_time?.includes('23:59:59')

        let startDate = moment(this.reportData.start_time).format('DD.MM.YYYY.')
        let endDate = moment(this.reportData.end_time).format('DD.MM.YYYY.')
        if(fullDays && startDate === endDate) {
            pr.l('L', `${i18n.t('general.date').toLowerCase()}: ${startDate}`, { align: 'C' })
        } else {
            const period = `${moment(this.reportData.start_time).format('DD.MM.YYYY. HH:mm:ss')} - ${moment(this.reportData.end_time).format('DD.MM.YYYY. HH:mm:ss')}`
            pr.l('L', period, { align: 'C' })
        }

        pr.l('L', '')
        pr.l('L', '')
        pr.l('L', '')

        pr.table({
            colNumber: 13,
            html: {
                colWidths: ['4%', null, '7%', '7%', '7%', '7%', '7%', '7%', '7%', '7%', '7%', '7%', '9%'],
                style: { fontSize: '12px', border: '1px solid black', color: 'black' },
            }
        })

        const headings = this.reportData.data[0].columns.map(column => {
            return {
                content: i18n.t(`reports.body.bar_ledger.columns.${column.key}`),
                align: column.align,
                style: {
                    padding: '4px',
                    border: '1px solid #444444',
                    verticalAlign: 'middle'
                }
            }
        })

        const cellStyle = { border: '1px solid #444444' }
        const summaryCellStyle = { border: '1px solid white;' }
        const subheadings = this.reportData.data[0].columns.map((column, index) => ({ content: index + 1, align: 'C', style: cellStyle }))

        pr.tl(...headings)
        pr.tl(...subheadings)

        this.reportData.data[0].items.forEach((item, rowIndex, arr) => {
            const style = rowIndex === arr.length - 1 ? summaryCellStyle : cellStyle
            const row = item.map((colContent, colIndex) => ({ content: colContent, align: headings[colIndex].align, style }))
            pr.tl(...row)
        })

        pr.l('L', '')
        pr.l('L', '')
        pr.l('L', '')
        pr.l('L', '')

        pr.table({
            colNumber: 2,
            html: {
                style: { color: 'black' }
            }
        })
        pr.tl(
            { content: i18n.t('general.created_by'), align: 'C' },
            { content: i18n.t('general.responsible_person'), align: 'C' },
        )
        pr.tl(
            { content: ' ', align: 'C' },
            { content: ' ', align: 'C' },
        )
        pr.tl(
            { content: '______________________________', align: 'C' },
            { content: '______________________________', align: 'C' },
        )

        return pr
    }
}
